import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {OptInMarketingReportData} from "./opt-in-marketing-report.data";

@Injectable()
export class OptInMarketingReportModel extends ReportModel<OptInMarketingReportData> {
    constructor(injector: Injector) {
        super(injector, OptInMarketingReportData);
    }
}
